import PropTypes from 'prop-types';
import { createContext, useEffect, useMemo, useState } from 'react';
import { getAllPages } from '../utils/API/user';
import { API } from '../constants';

const UserListContext = createContext({
  users: [],
  usersById: {},
  usersByUsername: {},
  isLoadingUsers: false,
});

const UserListContextProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const [isLoadingUsers, setIsLoadingUsers] = useState(true);

  useEffect(() => {
    getAllPages(API.USER_LIST)
      .then((allUsers) => {
        setUsers(
          allUsers.sort((a, b) =>
            (a.full_name || '').localeCompare(b.full_name || '')
          )
        );
      })
      .catch(() => setUsers([]))
      .finally(() => setIsLoadingUsers(false));
  }, []);

  const usersById = useMemo(
    () =>
      Object.freeze(Object.fromEntries(users.map((user) => [user.id, user]))),
    [users]
  );

  const usersByUsername = useMemo(
    () =>
      Object.freeze(
        Object.fromEntries(users.map((user) => [user.username, user]))
      ),
    [users]
  );

  return (
    <UserListContext.Provider
      value={{ users, usersById, usersByUsername, isLoadingUsers }}
    >
      {children}
    </UserListContext.Provider>
  );
};

UserListContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { UserListContext, UserListContextProvider };
